export default {
  GET_MODULE_LIST: '/manage/deepLink/module',
  GET_TABLE_LIST: '/manage/deepLink/findList',
  DELETE_DEEP_LINK: '/manage/deepLink/delete',
  SAVE: '/manage/deepLink/save',
  INCR_SCANNED_TIME: '/manage/deepLink/incrScannedTimes'
}



// WEBPACK FOOTER //
// ./src/axios/api_urls/deeplink.js